import axios from './api';


export default {
  getSupplies(page, q, type){
    if (isNaN(page) && q === undefined && type === undefined) {
      return axios.get(`/api/supplies/`).then(res => res.data);
    }
    if (q){
      return axios.get(`/api/supplies?page=${page}&type=${type}&q=${q}`).then(res => res.data)
    } else {
      return axios.get(`/api/supplies?page=${page}&type=${type}`).then(res => res.data)
    }
  },
  getSuppliesById(id) {
    return axios.get(`/api/supply/${id}`).then(res => res.data);
  },
  createSupply(supply) {
    return axios.post('/api/supply', supply).then(res => res.data);
  },
  removeSupply(id) {
    return axios.delete(`/api/supply/${id}`).then(res => res.data);
  },
  updateSupply(id, supply) {
    return axios.put(`/api/supply/${id}`, supply).then(res => res.data);
  },
}